module.exports = __webpack_public_path__ + "static/media/logo-white.256c2293.svg";